module.exports = __webpack_public_path__ + "static/img/manual-18.314d455.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-18.png
// module id = UJ9E
// module chunks = 4